<script>
  import { onMount } from "svelte";
  import { navigate } from "svelte-routing";

  let isAuthenticated = false;
  let isLoading = true;

  onMount(() => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    isAuthenticated = userData !== null;
    isLoading = false;
    if (!isAuthenticated) {
      window.location.href = "#/login";
      // setTimeout(() => {
      //   navigate("#/login");
      //   window.location.reload();
      // }, 3000);
    }
  });
</script>

{#if isLoading}
  <div class="loader"></div>
{:else if isAuthenticated}
  <slot />
{:else}
  <div class="loading-message">
    Please wait while we verify your authentication...
  </div>
{/if}

<style>
  .loader {
    border: 8px solid #f3f3f3;
    border-top: 8px solid #3498db;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    animation: spin 1s linear infinite;
    margin: auto;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .loading-message {
    text-align: center;
    font-size: 1.2rem;
    margin-top: 20px;
    max-width: 100%;
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 5px;
    background-color: #f9f9f9;
    text-align: center;
  }
</style>
